import { useAccount, useAccountFeatures, useSirenEntity, useStoreValues } from '~/utility/BinSentry-ui-utility';
import { useState } from 'react';
import _ from 'lodash';

export default function useOptionalColumns() {
  const { currentOrgHref, isProducer } = useStoreValues(['currentOrgHref', 'isProducer']);
  const { account, loading: accountLoading } = useAccount({ organizationId: currentOrgHref });
  const { features, loading: featuresLoading } = useAccountFeatures({ organizationId: account?.getLink('self').href });
  const { entity: integrations, loading: integrationsLoading } = useSirenEntity({ href: account?.getSubEntity('https://api.binsentry.com/rel/integrations')?.href });
  const { entity: fasIntegration, loading: fasIntegrationLoading } = useSirenEntity({ href: integrations?.getSubEntity('https://api.binsentry.com/rel/fas-integration')?.href });
  const fasPullOrdersEnabled = fasIntegration?.properties.pullOrdersEnabled;
  const loading = accountLoading || featuresLoading || integrationsLoading || fasIntegrationLoading;
  const result = {
    showOrderNumberColumn: !isProducer && (
      features.microsoftFinanceAndOperations === true
      || (features.fasOrders === true && fasPullOrdersEnabled)
    ),
    showIntegrationColumn: !isProducer && (features.microsoftFinanceAndOperations === true || features.fasOrders === true),
    showOrderNumberInStateColumn: !isProducer && !(features.microsoftFinanceAndOperations === true || features.fasOrders === true),
    features,
    loading,
  };
  const [publishedResult, setPublishedResult] = useState(result);
  if (_.isEqual(publishedResult, result)) {
    return publishedResult;
  }

  setPublishedResult(result);
  return result;
}
